export const SET_CONFIRMATION_MESSAGE = 'SET_CONFIRMATION_MESSAGE';
export const CLEAR_CONFIRMATION_MESSAGE = 'CLEAR_CONFIRMATION_MESSAGE';
